import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../app/store';
import { authService } from '../pages/Auth/authService';
import { logout } from '../features/auth/authSlice';
import { toast } from 'react-toastify';


const ProtectedRoute: React.FC = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const [isLoading, setIsLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const validateToken = async () => {
      try {
        // Check if we have tokens
        const tokens = authService.getTokens();
        if (!tokens.accessToken || !tokens.refreshToken) {
          setIsValid(false);
          setIsLoading(false);
          return;
        }

        // Check if token is valid or needs refresh
        const validToken = await authService.getValidToken();
        if (validToken) {
          setIsValid(true);
        } else {
          // Token validation failed
          dispatch(logout());
          setIsValid(false);
        }
      } catch (error) {
        // console.error('Token validation error:', error);
        toast.error('Session validation failed. Please log in again.');
        dispatch(logout());
        setIsValid(false);
      } finally {
        setIsLoading(false);
      }
    };

    validateToken();
  }, [dispatch]);

  // Show loading state while validating
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
          <p className="mt-4 text-gray-600">Validating session...</p>
        </div>
      </div>
    );
  }

  // If no user or invalid token, redirect to login
  if (!user || !isValid) {
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render child routes
  return <Outlet />;
};

export default ProtectedRoute;